import CONFIGS from 'configs';
import fr from './fr.json';

const clientSpecificTranslations = {}[CONFIGS.ENV] || {};

export default { ...fr, ...clientSpecificTranslations };
